module.exports = __webpack_public_path__ + "static/media/bg-login.ce782211.jpg";